import React, { useState } from "react";
import { Modal } from "@/components/Modal";
import { ABtn, AResult } from "@/components/games/arcadeUi";

const TARGETS = [
  { g: 100, l: "100 gram" },
  { g: 250, l: "paav (250g)" },
  { g: 500, l: "aadha kilo (500g)" },
  { g: 750, l: "paun kilo (750g)" },
];
const WEIGHTS = [50, 100, 250, 500];
const pick = () => TARGETS[Math.floor(Math.random() * TARGETS.length)];

export const WeighingGame = ({ open, onClose }) => {
  const [target, setTarget] = useState(pick);
  const [pan, setPan] = useState(0);
  if (!open) return null;
  const done = pan === target.g;
  const tilt = Math.max(-14, Math.min(14, (pan - target.g) / 40));
  const next = () => { setTarget(pick()); setPan(0); };

  return (
    <Modal open={open} onClose={onClose} testId="weigh-modal" maxWidth="max-w-md">
      <div className="p-6 text-center">
        <h2 className="font-signboard text-2xl font-bold text-kirana-brown">⚖️ Taraazu — Tol do</h2>
        <p className="mt-1 text-sm text-kirana-brown/70">Kaka bole: <b>"{target.l} tol do beta."</b></p>

        <div className="relative mx-auto my-7 h-40 w-64">
          <div className="absolute left-1/2 top-6 h-24 w-1.5 -translate-x-1/2 rounded bg-kirana-brown" />
          <div className="absolute bottom-4 left-1/2 h-3 w-10 -translate-x-1/2 rounded bg-kirana-brown" />
          <div className="absolute left-1/2 top-6 h-2 w-60 origin-center rounded bg-kirana-brown transition-transform duration-300" style={{ transform: `translateX(-50%) rotate(${tilt}deg)` }}>
            <div className="absolute -left-1 top-1 flex -translate-x-1/2 flex-col items-center">
              <div className="h-7 w-px bg-kirana-brown" />
              <div className="flex h-9 w-16 items-center justify-center rounded-b-2xl border-2 border-kirana-brown bg-[#cdbb93] text-xs font-bold text-kirana-brown">{target.g}g</div>
            </div>
            <div className="absolute -right-1 top-1 flex translate-x-1/2 flex-col items-center">
              <div className="h-7 w-px bg-kirana-brown" />
              <div data-testid="weigh-pan" className="flex h-9 w-16 items-center justify-center rounded-b-2xl border-2 border-kirana-brown bg-kirana-gold text-xs font-bold text-kirana-brown">{pan}g</div>
            </div>
          </div>
        </div>

        <div className="flex flex-wrap justify-center gap-2">
          {WEIGHTS.map((w) => (
            <ABtn key={w} data-testid={`weigh-add-${w}`} onClick={() => !done && setPan((p) => p + w)} tone="gold">+{w}g</ABtn>
          ))}
          <ABtn data-testid="weigh-reset" onClick={() => setPan(0)}>Empty pan</ABtn>
        </div>

        {done && (
          <>
            <AResult testId="weigh-result" win text="Perfect tol! 🎯 Shabaash beta." />
            <div className="mt-3 flex justify-center"><ABtn data-testid="weigh-next" onClick={next} tone="green">Next order</ABtn></div>
          </>
        )}
      </div>
    </Modal>
  );
};
